import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import * as _ from 'underscore';
import {change} from 'redux-form';

import CustomList_1cells from "./CustomList_1cells";
import CustomList_3cells from "./CustomList_3cells";
import CustomList_2cells from "./CustomList_2cells";
import CustomList_4cells from "./CustomList_4cells";
import CustomList_7cells from "./CustomList_7cells";

const resolveMacro = (macro) => {
    const match = macro.match(/^(\dcells)_(.+)$/);
    if (!match) return null;

    const [, template, params] = match;
    const nums = params.split('_').map(Number);

    switch (template) {
        case '1cells': // 1cells_11_1
            return { rowTemplate: '1cells', rowTemplate_cols: [2, 10, nums[0], nums[1]] };
        case '2cells': // 2cells_3_9, 2cells_4_8
            return { rowTemplate: '2cells', rowTemplate_cols: [2, 10, nums[0], nums[1], 3, 8, 1] };
        case '3cells': // TODO
            return { rowTemplate: '3cells', rowTemplate_cols: [2, 10, ...nums] };
        case '4cells': // TODO
            return { rowTemplate: '4cells', rowTemplate_cols: [ 2, 10, 1, 4, 6, 6, 3, 6, 6, 4, 6, 4, 2 ] };
        default:
            return null;
    }
};

const CustomList = (props) => {
    const form = useSelector(state => state.form);
    const dispatch = useDispatch();
    const defaultValues = {placeholder: 'details'}

    const resolved = props.row_macro ? resolveMacro(props.row_macro) : null;
    const config = resolved
        ? { ...defaultValues, ...props, ...resolved }
        : { ...defaultValues, ...props};

    const counterVar = () => `${config.namePrefix}_count`;
    const rowsCount = () => form.wizard.values[counterVar()];

    const supportedTemplates = ["1cells", "2cells", "3cells", "4cells", "7cells"];
    if (!supportedTemplates.includes(config.rowTemplate)) {
        return (
            <div className="col-12 col-lg-12 custom-list-error" style={{ color: 'red' }}>
                CustomList configuration error: unsupported rowTemplate "{String(config.rowTemplate)}".
                Supported values: {supportedTemplates.join(', ')}.
            </div>
        );
    }

    if (!rowsCount()) {
        dispatch(change('wizard', counterVar(), config.defaultRowsCount || 3));
        return null;
    } else {
        const renderRow = (key) => {
            switch (config.rowTemplate) {
                case "1cells":
                    return <CustomList_1cells key={key} config={config} rowKey={key} last={(key+1) === rowsCount()}/>;
                case "2cells":
                    return <CustomList_2cells key={key} config={config} rowKey={key} last={(key+1) === rowsCount()}/>;
                case "3cells":
                    return <CustomList_3cells key={key} config={config} rowKey={key} last={(key+1) === rowsCount()}/>;
                case "4cells":
                    return <CustomList_4cells key={key} config={config} rowKey={key} last={(key+1) === rowsCount()}/>;
                case "7cells":
                    return <CustomList_7cells key={key} config={config} rowKey={key} last={(key+1) === rowsCount()}/>;
            }

        }

        const renderList = () => _.range(rowsCount()).map((value, index) => renderRow(index));
        const renderError = () => {
            if (config.error && config.customError) {
                return <div className="col-12 col-lg-12 custom-list-error ">{config.customError}</div>
            }
            return null;
        }


        return <>
                {renderError()}
                {renderList()}
            </>;
    }
}

export default CustomList;